export default __webpack_public_path__ + "static/user4-e5942e5553c6971723b75cbb145b3fba.jpg";